import {styled} from "@mui/material/styles"

export const SelectedFacetIndicator = styled("div")`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0.375rem;
    margin: auto;
    height: 0.25rem;
    width: 0.25rem;
    background: ${({theme}) => theme.colours.form.buttonPrimary.background};
    border-radius: 50%;
`

export const ShowFiltersStyling = styled("div")`
    ${({theme}) =>
        `white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${theme.colours.text.muted};`}
`
